<script setup>
import {computed, ref, watch} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    tableName: String,
    id: Number
})

const componentsStore = useComponentsStore()
const itemDataStore = useItemDataStore()

// --- State & Async ---

// Reactive ref to hold the fetched item
const item = ref(null)

// Native watcher handles initial fetch and updates whenever id or tableName changes
watch(
    () => [props.id, props.tableName],
    async ([newId, newTable]) => {
        if (newId && newTable) {
            item.value = await itemDataStore.get({
                tableName: newTable,
                id: newId
            })
        } else {
            item.value = null
        }
    },
    {immediate: true}
)

// --- Computed ---

const componentId = computed(() => {
    return componentsStore.componentIds[props.tableName]
})

const nameField = computed(() => {
    // Looks up which field acts as the "Title/Name" for this specific table
    return componentsStore.nameField(componentId.value)
})

const displayTitle = computed(() => {
    if (item.value && nameField.value) {
        return item.value[nameField.value]
    }
    return '...' // Placeholder while loading
})
</script>

<template>
    <span>{{ displayTitle }}</span>
</template>